import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
    closeWindow as closeWindowAC,
    openWindow as openWindowAC,
} from './actions'

export const useWindowActions = () => {
    const dispatch = useDispatch()

    const openWindow = useCallback(
        (name, props = null) => {
            dispatch(openWindowAC(name, props))
        },
        [dispatch]
    )

    const closeWindow = useCallback(() => {
        dispatch(closeWindowAC())
    }, [dispatch])

    return {
        openWindow,
        closeWindow,
    }
}
